function debounce(func: (...args: unknown[]) => void, milliseconds = 100) {
    let timer: ReturnType<typeof setTimeout>;

    return function (...args: unknown[]) {
        if (timer) clearTimeout(timer);

        timer = setTimeout(func, milliseconds, ...args);
    };
}

function yieldToMain(): Promise<void> {
    const scheduler = window.scheduler;

    if (scheduler && typeof scheduler.yield === 'function') {
        return scheduler.yield();
    }

    return new Promise((resolve) => setTimeout(resolve, 0));
}

export { debounce, yieldToMain };
